// extracted by mini-css-extract-plugin
export default {"text_primary":"Thankyou_text_primary__6HPkG","close":"Thankyou_close__02h5e"};